import baseHttpService from "core/http/singleton/base";
import { FileTypes } from "redux-store/static/redux/file";

export const getImageResponseApi = async (imageId: string, type: FileTypes) => {
  const res = await baseHttpService.get(
    imageId,
    {},
    {
      responseType: "arraybuffer",
      headers:
        type === FileTypes.PDF_DOCUMENT
          ? {
              "Content-Type": "application/pdf",
            }
          : {},
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res;
};

export const downloadFileApi = async (fileUrl: string) => {
  const res = await baseHttpService.get(
    fileUrl,
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "*/*", // chấp nhận tất cả định dạng trả về
        "Content-Type": "application/octet-stream", // định dạng chung cho file nhị phân
      },
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res;
};

export const downloadFile = async (fileUrl: string, fileName: string) => {
  const res: any = await downloadFileApi(fileUrl);

  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};
